import React, { useState, useContext, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import styled from "styled-components";
import Color from "color";
//import csv from 'csv';
import CSVReader from "react-csv-reader";
import {
  useTheme,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Grid,
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Button } from "../../components/ui/forms/Button";
import Spinner from "../../components/ui/Spinner";
import { DatabaseContext } from "../../contexts/DatabaseContext";
import { UserContext } from "../../contexts/UserContext";
import { PatronContext } from "../../contexts/PatronContext";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";

const SRCSVImport = () => {
  const [patrons, setPatrons] = useState([]);
  const [loading, setLoading] = useState(false);

  const { importPatrons } = useContext(PatronContext);
  const { apiUrl } = useContext(DatabaseContext);
  const { Site } = useContext(UserContext);
  const { palette } = useTheme();

  const handleForce = (data, fileInfo) => {
    let patronsArr1 = [];
    let errorArr = [];
    data.forEach((patron) => {
      patron.dateOfBirth = patron.dateOfBirth;
      patronsArr1.push({
        siteCode: Site.siteCode,
        externalID: patron.externalid,
        firstName: patron.firstnames,
        lastName: patron.lastname,
        dateOfBirth: patron.dob__yyyy_mm_dd_,
        custom1: patron.custom1 || "",
        custom2: patron.custom2 || "",
        custom3: patron.custom3 || "",
      });
    });

    setPatrons(patronsArr1);
  };

  const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    transformHeader: (header) => header.toLowerCase().replace(/\W/g, "_"),
  };

  const onDrop = useCallback((acceptedFiles) => {
    const convertPatronsToObjects = (patrons) => {
      let patronsArr = [];
      let errorArr = [];

      patrons.forEach((patron) => {
        if (patron[0]) {
          patronsArr.push({
            siteCode: Site.siteCode,
            externalID: patron[0],
            firstName: patron[1],
            lastName: patron[2],
            dateOfBirth: patron[3] || "",
            custom1: patron[4] || "",
            custom2: patron[5] || "",
            custom3: patron[6] || "",
          });
        } else {
          errorArr.push(patron);
        }
      });

      return { patronsArr, errorArr };
    };

    const file = acceptedFiles[0];

    const reader = new FileReader();
    reader.onload = () => {
      // csv.parse(reader.result, (err, data) => {
      //   data.shift();
      //   const { patronsArr } = convertPatronsToObjects(data);
      //   setPatrons(patronsArr);
      // });
    };
    reader.readAsBinaryString(file);
    //eslint-disable-next-line
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  });

  const importToDatabase = async (patrons) => {
    setLoading(true);
    await importPatrons(patrons);
    setPatrons([]);
    setLoading(false);
  };

  const tableHeaders = [
    {
      label: "ID",
      dataKey: "externalID",
    },
    {
      label: "First Name",
      dataKey: "firstName",
    },
    {
      label: "Last Name",
      dataKey: "lastName",
    },
    {
      label: "DOB (YYYY-MM-DD)",
      dataKey: "dateOfBirth",
    },
    {
      label: Site.custom1 ?? "Custom 1",
      dataKey: "custom1",
    },
    {
      label: Site.custom2 ?? "Custom 2",
      dataKey: "custom2",
    },
    {
      label: Site.custom3 ?? "Custom 3",
      dataKey: "custom3",
    },
  ];

  return (
    <Container>
      {!patrons.length > 0 && (
        <Header container spacing={2}>
          <Grid item md={2}>
            {/* <DropzoneContainer>
              <Dropzone
                {...getRootProps()}
                //isDrag={isDragActive}
                colour={palette.success.main}
              >
                <input {...getInputProps()} name="csv" accept=".csv" />
                {/* <Icon
                icon={isDragActive ? <InsertDriveFileIcon/> : <ArrowDownwardIcon/> }
                 
                  size='4x'
                  style={{ marginBottom: '2rem' }}
                /> 
                <InsertDriveFileIcon style={iconStyles} />
                <br />
                <Text>Drag and drop a .CSV here, or click to select</Text>
              </Dropzone>
            </DropzoneContainer> */}
          </Grid>
          <Grid item md={8}>
            <Info>
              <Text variant="h4" gutterBottom>
                IMPORTANT INFORMATION
              </Text>
              <br />
              <Text style={displayStyles}>
                Please make sure your data file is correct as per the steps
                below:
              </Text>
              <ul>
                <li>
                  Dates of birth are formatted as YYYY-MM-DD ( Example:{" "}
                  <b>2004-04-20</b>)
                </li>
                <li>
                  Any space in external ID field will be removed as part of
                  importing process.
                </li>
                <li>
                  This process will import data <b>BUT</b> will not order any
                  smartrider cards
                </li>
                <li>
                  Use/Download the template for your spreadsheet: (include the
                  header row){" "}
                </li>
                <li>
                  Don't change the names of the columns in the
                  spreadsheet/template
                </li>
              </ul>
              <label htmlFor={"upload-button"} style={inputStyles}>
                Upload Data Import File (click on 'Choose File' button)
              </label>
              <CSVReader
                className="uploadButton"
                id="upload-button"
                label=""
                inputStyle={{
                  position: "absolute",
                  //left: 0,
                  height: "50px%",
                  width: "400px",
                  cursor: "pointer",
                  opacity: 100,
                }}
                onFileLoaded={handleForce}
                parserOptions={papaparseOptions}
              ></CSVReader>
            </Info>
          </Grid>
          <Grid item md={2}>
            <form
              method="get"
              action={`${apiUrl}/downloads/idcapture_import_template_id.csv`}
            >
              <StyledButton
                type="submit"
                colour="success"
                startIcon={<GetAppIcon />}
                variant="contained"
              >
                Download Template
              </StyledButton>
            </form>
          </Grid>
        </Header>
      )}

      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {tableHeaders.map(({ label, dataKey }) => (
                <TableCell key={dataKey}>
                  <Typography
                    variant="caption"
                    style={{ fontWeight: 700, textTransform: "uppercase" }}
                  >
                    {label}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {patrons.map((patron) => (
              <TableRow key={patron.externalID}>
                <TableCell>{patron.externalID}</TableCell>
                <TableCell>{patron.firstName}</TableCell>
                <TableCell>{patron.lastName}</TableCell>
                <TableCell>{patron.dateOfBirth}</TableCell>
                <TableCell>{patron.custom1}</TableCell>
                <TableCell>{patron.custom2}</TableCell>
                <TableCell>{patron.custom3}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {patrons.length > 0 && (
        <Actions background={palette.background.default}>
          {loading ? (
            <Spinner />
          ) : (
            <Button
              onClick={() => importToDatabase(patrons)}
              colour="success"
              margin="0 1rem 0 0"
            >
              Import
            </Button>
          )}
          <Button
            onClick={() => setPatrons([])}
            colour="error"
            disabled={loading}
          >
            Clear
          </Button>
        </Actions>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;

const Header = styled(Grid)`
  margin-bottom: 2rem;
`;

const Info = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-left: 2rem;
  padding: 1rem 0;
  border-radius: 1rem;
`;

const Text = styled(Typography)`
  display: flex;
  align-items: center;
`;

const Example = styled(Typography)`
  font-size: 1.8rem;
  font-family: monospace;
  padding: 0.5rem 1rem;
  margin: 1rem 0 1rem 0.5rem;
  border-radius: 3px;
  background: ${(props) => Color(props.colour).fade(0.9).string()};
`;

const DropzoneContainer = styled.div`
  display: flex;
`;

const Dropzone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 2px ${(props) => (props.isDrag ? "dashed" : "solid")};
  border-radius: 1rem;
  padding: 2rem;
  cursor: pointer;
  &:hover {
    background: ${(props) => Color(props.colour).fade(0.8).string()};
  }
  &:active {
    background: ${(props) =>
      Color(props.colour).darken(0.9).fade(0.8).string()};
  }
`;

const StyledButton = styled(Button)`
  margin-top: 1rem;
  background: ${(props) => props.colour};
`;

const Actions = styled.div`
  display: flex;
  padding-top: 2rem;
  margin-top: auto;
  width: 100%;
  background: ${(props) => props.background};
  border-radius: 2rem;
`;

const iconStyles = {
  fontSize: "65px",
};

const displayStyles = {
  fontWeight: "Bold",
  fontSize: "16px",
};

const inputStyles = {
  fontWeight: "Bold",
  fontSize: "20px",
};

export default SRCSVImport;
